import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, GuardResult, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const appAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot, 
  state: RouterStateSnapshot): GuardResult => {

  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const isAuthenticated = authService.isAuthenticated();
  if (!isAuthenticated) {
    authService.redirectUrl = state.url;
    return router.createUrlTree(['/login']);
  } 

  return isAuthenticated;
};